import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import css from 'css';
import WP from 'WP';
import HeadMeta from 'partials/HeadMeta';
import Footer from 'partials/Footer';
import ErrorBoundary from 'partials/ErrorBoundary';
import { clearCart } from 'store';

//Stripe related imports
import { Elements, StripeProvider } from 'react-stripe-elements';
import PaymentForm from 'partials/stripe/PaymentForm';

import { setCurrentView } from 'store';

class StripePage extends Component {

    componentDidMount() {
        this.mounted = true;
		this.props.clearCart();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return (
            <Wrapper pageBackground='white'>

                <HeadMeta />

                <ErrorBoundary for="stripe-payment-module">
					<div style={{ display: 'flex', flex: 1, flexDirection: 'column', minHeight: '80vh', alignItems: 'center', justifyContent: 'center'}}>
						<StripeProvider apiKey={WP.options.stripe_api_public_key}>
							<Elements>
								<PaymentForm />
							</Elements>
						</StripeProvider>
					</div>
                </ErrorBoundary>

                <ErrorBoundary for="Footer">
                    <Footer/>
                </ErrorBoundary>

            </Wrapper>
        );
    }
}

const mapStateToProps = (state, props) => ({
    page: state.pages[props.match.params.slug] || null
});

const actions = {
    setCurrentView,
	clearCart,
}

export default connect(mapStateToProps, actions)(withRouter(StripePage));

const Wrapper = styled.div`
    display:block;
    position:relative;
    width:100%;

    background: ${props => css.colors[props.pageBackground]};
`


// WEBPACK FOOTER //
// ./src/views/StripePage.js